import { simpleSet } from '@r/reducers/utils';

const setAddWallMode = simpleSet as redux.reducers.floorPlanTools.addWallMode;
export const addWallMode = setAddWallMode(
  'SET_ADD_WALL_MODE',
  false
);
